import { AbstractRequestHandler } from "@yuigoto/abst";
import { Url } from "@yuigoto/validators";
import axios from "axios";
import { 
  CreateRequestObject, 
  CreateRequestUrlObject 
} from "core/utils/RequestObject";

/**
 * core/glambox/GlamboxRequestHandler
 * ----------------------------------------------------------------------
 * Singleton utilizado para gerenciamento de requests HTTP utilizando a 
 * biblioteca `axios` (por compatibilidade).
 * 
 * @since     0.0.1
 */
export class GlamboxRequestHandler extends AbstractRequestHandler {
  /**
   * @type {GlamboxRequestHandler}
   */
  static $$;
  
  // LIFECYCLE
  // --------------------------------------------------------------------

  /**
   * Meh.
   */
  constructor () {
    super(
      process.env.REACT_APP_GB_API_ROOT 
        || "https://api.glambox.com.br"
    );

    if (
      GlamboxRequestHandler.$$ !== null 
        && GlamboxRequestHandler.$$ !== undefined
    ) {
      return GlamboxRequestHandler.$$;
    }

    GlamboxRequestHandler.$$ = this;
  }

  // MÉTODOS PÚBLICOS
  // --------------------------------------------------------------------

  /**
   * Executes a request directly to an endpoint and/or URL.
   *
   * @param {*} endpoint 
   *     Objeto de endpoint, contendo URL, métodos aceitos e eventuais parâmetros 
   *     que sejam obrigatórios 
   * @param {object} data 
   *     Objeto contendo dados para envio, caso `endpoint` possua o parâmetro 
   *     `required` as chaves contidas neste objeto serão validadas com base nele 
   * @param {string} method 
   *     Método HTTP a ser utilizado para o request 
   * @param {object} headers 
   *     Objeto contendo pares chave/valor referentes aos headers de página 
   * @param {object} params 
   *     Objeto opcional, contendo pares chave/valor com parâmetros de URL, para 
   *     replacement direto na string, caso a string `url` em endpoint possua 
   *     algum parâmetro, declarar este parâmetro é obrigatório 
   * @returns {Promise<any>} 
   */
  async request (
    endpoint, 
    data, 
    method, 
    headers = null, 
    params = null
  ) {
    try {
      if (!this.isValidEndpoint(endpoint.url)) {
        throw new TypeError(`Endpoint inválido.`);
      }

      if (!headers) {
        this.addHeader("Content-Type", "application/json");
      }
      let axiosRequestObject = CreateRequestObject(
        endpoint, 
        data,
        method,
        Object.assign({}, this.headers, (headers) ? headers : {}),
        params
      );

      if (false === axiosRequestObject) return false;
      
      axiosRequestObject = Object.assign(
        {},
        axiosRequestObject, 
        {
          baseURL: this.baseUrl, 
          responseType: "json"
        }
      );

      return axios(axiosRequestObject);
    } catch (e) {
      console.error(e)
      console.error(e.response);
      return false;
    }
  }

  /**
   * Executa um request diretamente em uma URL.
   *
   * @param {string} url 
   *     URL completa para onde o request será enviado 
   * @param {object} data 
   *     Objeto contendo dados para envio, caso `required` seja declarado, 
   *     as chaves contidas neste objeto serão validadas com base nele 
   * @param {string} method 
   *     Método HTTP a ser utilizado para o request 
   * @param {object} headers 
   *     Objeto contendo pares chave/valor referentes aos headers de página 
   * @param {string[]} required 
   *     Opcional, deve conter as chaves a ser consideradas como obrigatórias 
   *     dentro dos dados a serem enviados 
   * @returns {Promise<any>} 
   */
  async requestUrl (url, data, method, headers, required) {
    try {
      if (!Url.validate(url)) {
        throw new TypeError(`URL inválida.`);
      }

      if (!headers) {
        this.addHeader("Content-Type", "application/json");
      }

      let axiosRequestObject = CreateRequestUrlObject(
        url, 
        data,
        method,
        Object.assign({}, this.headers, (headers) ? headers : {}),
        required
      );

      axiosRequestObject = Object.assign(
        {},
        axiosRequestObject, 
        {
          responseType: "json"
        }
      );

      return await axios(axiosRequestObject);
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
